module.exports = __webpack_public_path__ + "img/icon-search-sp.6be0f742.svg";